import { Grid, Tooltip } from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageMode } from 'civil-status/view-models/page-mode';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { CivilStatusAuthorizations } from 'shell/authorizations/civil-status';
import { PmiButton } from 'shell/components/shared/button';

export const authsObject = Object.freeze({
  annotation: [CivilStatusAuthorizations.AnnotazioneIntNaz],
  edit: [CivilStatusAuthorizations.AttoModifica],
  sostituzione: [CivilStatusAuthorizations.AttoSostituzione],
});

interface ButtonsFormProps {
  mode: PageMode;
  onDetailMode: () => void;
  onEditMode: () => void;
  onSubstitutionMode: () => void;
  onAnnotationNationalMode: () => void;
  onAnnotationInternationalMode: () => void;
  onPrintMode: () => void;
  onAnnotationInternationalDeleteAll: () => void;
  onAnnotationNationalDeleteAll: () => void;
  url?: string;
}

const ButtonsFormComponent = ({
  mode,
  onDetailMode,
  onEditMode,
  onSubstitutionMode,
  onAnnotationNationalMode,
  onAnnotationInternationalMode,
  onAnnotationInternationalDeleteAll,
  onAnnotationNationalDeleteAll,
  url = '/stato-civile/nascita/ricerca',
}: ButtonsFormProps): React.ReactElement => {
  const navigate = useNavigate();

  const auths = useActionAuthorization(authsObject);

  return (
    <>
      {mode === PageMode.Substitution ? (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
              Salva
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiButton
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                onDetailMode();
              }}
            >
              Indietro
            </PmiButton>
          </Grid>
        </Grid>
      ) : undefined}
      {mode === PageMode.Print ? (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
              Salva
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiButton
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                onDetailMode();
              }}
            >
              Indietro
            </PmiButton>
          </Grid>
        </Grid>
      ) : undefined}
      {mode === PageMode.Edit ? (
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
              Salva
            </PmiButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiButton
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                onDetailMode();
              }}
            >
              Indietro
            </PmiButton>
          </Grid>
        </Grid>
      ) : undefined}
      {mode === PageMode.Detail ? (
        <>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  auths.edit ? '' : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onEditMode();
                    }}
                  >
                    Modifica
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  auths.sostituzione
                    ? ''
                    : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onSubstitutionMode();
                    }}
                    disabled={!auths.sostituzione}
                  >
                    Sostituisci
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  auths.annotation
                    ? ''
                    : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    disabled={!auths.annotation}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onAnnotationNationalMode();
                    }}
                  >
                    Annot. Italia
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={4}>
              <Tooltip
                arrow
                title={
                  auths.annotation
                    ? ''
                    : "Non si ha l'autorizzazione per accedere a questa funzionalità"
                }
              >
                <span>
                  <PmiButton
                    variant="outlined"
                    color="cdmBrandThird"
                    fullWidth
                    disabled={!auths.annotation}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      onAnnotationInternationalMode();
                    }}
                  >
                    Annot. Internaz.
                  </PmiButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={() => navigate(url)}
              >
                Indietro
              </PmiButton>
            </Grid>
          </Grid>
        </>
      ) : undefined}
      {mode === PageMode.International ? (
        <>
          <Grid item container spacing={2} xs={12}>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="contained"
                color="cdmBrand"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onAnnotationInternationalDeleteAll();
                }}
              >
                Elimina tutte
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onDetailMode();
                }}
              >
                Indietro
              </PmiButton>
            </Grid>
          </Grid>
        </>
      ) : undefined}
      {mode === PageMode.National ? (
        <>
          <Grid item container spacing={2} xs={12}>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="contained"
                color="cdmBrand"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onAnnotationNationalDeleteAll();
                }}
              >
                Elimina Tutte
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onDetailMode();
                }}
              >
                Indietro
              </PmiButton>
            </Grid>
          </Grid>
        </>
      ) : undefined}
    </>
  );
};

ButtonsFormComponent.displayName = 'Buttons form component';

const ButtonsForm = memo(ButtonsFormComponent);

export default ButtonsForm;
